import { getVINData } from "../services/vehicles";

const Model = {
  state: {
    data: [],
  },
  namespace: "vehicleForm",
  effects: {
    *validateVIN({ payload }, { call, put }) {
      const response = yield call(getVINData, payload);
      yield put({
        type: "vinInfo",
        payload: response,
      });

      return response;
    },
  },
  reducers: {
    newVehicle(state, { payload }) {
      return { ...state, data: payload };
    },
    vinInfo(state, { payload }) {
      return { ...state, data: payload };
    },
  },
};
export default Model;
